import { queryParams } from '@/plugins/axios';

export function all(context, payload) {
  const getUrl = `/communities/${queryParams(payload)}`;

  return this._vm.$axios.get(getUrl).then((response) => {
    const { data } = response;
    // console.log('store.communities.actions.all() axios then', data, response.status, response.statusText);

    return context.dispatch('setCommunities', { data: data.posts });
  });
}

export function setCommunities(context, payload) {
  // console.log('store.communities.actions.setCommunities()', payload);
  context.commit('setCommunities', payload.data);

  return payload.data;
}

export function setCommunityAttribute(context, payload) {
  // console.log('store.communities.actions.setCommunityAttribute()', payload);
  context.commit('setCommunityAttribute', payload);
}

export function setFilter(context, payload) {
  console.log('store.communities.actions.setCommunityFilter()', payload);
  context.commit('setFilter', payload);
}
